import { api, handleResponse, handleError } from "./apiServices";

export const addTandC = (token, data) =>
  api(token)
    .post("/api/T&C/terms&condition/addTandC", data)
    .then(handleResponse)
    .catch(handleError);

export const getTandC = token =>
  api(token)
    .get("/api/T&C/terms&condition/getTandC")
    .then(handleResponse)
    .catch(handleError);
